module.exports = __webpack_public_path__ + "img/brussels.3375e841.jpg";